<template>
  <smart-banner
    bg-color="#FFFFFF"
    direction="row"
    :has-kicker="true"
    kicker-color="#717D96"
    kicker-weight="700"
    kicker-align="left"
    title-color="#000000"
    title-size="h2"
    title-weight="400"
    title-align="left"
    text-color="#43515A"
    text-size="xs"
    text-weight="400"
    text-align="left"
    :has-button="true"
    :has-image="true"
    :image-mobile="imageMobile"
    :image-tablet="imageTablet"
    :image-desktop="imageDesktop"
    :alt="alt"
    :has-video="false"
  >
    <template #breadcrumb>
      <slot name="primary-breadcrumb" />
    </template>
    <template #kicker>
      <slot name="primary-kicker" />
    </template>
    <template #title>
      <slot name="primary-title" />
    </template>
    <template #text>
      <slot name="primary-text" />
    </template>
    <template #button>
      <slot name="primary-buttons" />
    </template>
  </smart-banner>
</template>

<script>
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-primary',
  components: {
    SmartBanner,
  },
  props: {
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    alt: {
      type: String,
    },
  },
}
</script>
